import { Button, Divider, Drawer, Menu, Spin } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { getMenuItemByKey, menuOptions } from './menuOptions';
import { VerticalMenuItem } from './VerticalMenuItem';
import UserLoginForm from '../../UserLoginForm';
import { usePreventScroll } from '../../../../utils/hooks';
import { useMenuActions } from './useMenuActions';

export function DefaultMenuDrawer({
  isOpen,
  setIsOpen,
  setIsCatchReportOpen,
  loading,
  isLoggedIn,
  handleLogOut,
}) {
  const { openCatchReport, openCrossing } = useMenuActions(isLoggedIn);
  return (
    <MenuDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      showFooter={loading || isLoggedIn}
    >
      <Menu selectedKeys={[]}>
        {menuOptions.map((option) => {
          return (
            <VerticalMenuItem
              {...option}
              onClick={() => {
                if (option.key === 'catch') {
                  if (openCatchReport()) {
                    setIsOpen(false);
                  }
                } else if (option.key === 'crossing') {
                  openCrossing();
                  setIsOpen(false);
                } else {
                  setIsOpen(false);
                }
              }}
            />
          );
        })}
      </Menu>
      <Divider />
      {loading ? (
        <div className='txt-center'>
          <Spin />
        </div>
      ) : isLoggedIn ? (
        <>
          <Menu className={'mg-bottom-10'} selectedKeys={[]}>
            <VerticalMenuItem
              {...getMenuItemByKey('profile')}
              favourMobileIcon
            />
          </Menu>
          <Button className={'mobile-logout-btn'} onClick={handleLogOut}>
            Log Out
          </Button>
        </>
      ) : (
        <UserLoginForm useMobileButtonStyle />
      )}
    </MenuDrawer>
  );
}

export default function MenuDrawer({
  isOpen,
  setIsOpen,
  showFooter,
  children,
}) {
  // Prevent background app scroll when drawer is open
  usePreventScroll('MenuDrawer', isOpen);

  return (
    <Drawer
      title={null}
      closeable={false}
      placement='right'
      onClose={() => setIsOpen(false)}
      open={isOpen}
      width={'min(100%, 30rem)'}
      headerStyle={{ display: 'none' }}
      className={'drawer-menu-mobile'}
      zIndex={1004}
    >
      <div className={'drawer-menu-mobile__header'}>
        <Button type={'text fs-28 white'} onClick={() => setIsOpen(false)}>
          <CloseCircleOutlined />
        </Button>
      </div>
      <div className={'drawer-menu-mobile__contents'}>{children}</div>
      {showFooter && (
        <div className={'drawer-menu-mobile__footer txt-center'}>
          <img
            src={process.env.PUBLIC_URL + '/assets/Logos/fish.png'}
            alt={'Swimbooker fish logo'}
          />
        </div>
      )}
    </Drawer>
  );
}
